import React from 'react';
import { Container } from '@chakra-ui/react';
import DashboardHeader from './DashboardHeader';
import DashboardStats from './DashboardStats';
import QuickActions from './QuickActions';
import RecentActivity from './RecentActivity';
import SetupChecklist from './SetupChecklist';

interface DashboardOverviewProps {
  firstName?: string;
  onCreateTask: () => void;
  onCreateProject: () => void;
  onCreateClient: () => void;
}

const DashboardOverview: React.FC<DashboardOverviewProps> = ({
  firstName,
  onCreateTask,
  onCreateProject,
  onCreateClient,
}) => {
  return (
    <Container maxW="" p={0}>
      <DashboardHeader firstName={firstName} />
      <SetupChecklist />
      <DashboardStats />
      <QuickActions
        onCreateTask={onCreateTask}
        onCreateProject={onCreateProject}
        onCreateClient={onCreateClient}
      />
      <RecentActivity />
    </Container>
  );
};

export default DashboardOverview;
